import { default as MdIconButton } from '@mui/material/IconButton'
import cx from 'classnames'
import React from 'react'
import css from './iconButton.css'

const IconButton = ({ className, children, ...props }: any) => (
  <MdIconButton className={cx(className, css.iconButton)} {...props}>
    {children}
  </MdIconButton>
)

export default IconButton
